import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal } from '@citrus/modal';
import { PrimaryButton, SecondaryButton } from '@citrus/button';
import { dismissConfirmationModal, confirm } from './confirmation.actions.js';

class ConfirmationModal extends Component {
  static defaultProps = {
    size: 'small',
    confirmText: 'Yes',
    dismissText: 'No'
  };

  static propTypes = {
    headerText: PropTypes.string.isRequired,
    size: PropTypes.string,
    body: PropTypes.node.isRequired,
    visible: PropTypes.bool,
    onConfirmCallback: PropTypes.func.isRequired,
    onDismissCallback: PropTypes.func,
    dismissConfirmationModal: PropTypes.func,
    confirm: PropTypes.func,
    confirmDisabled: PropTypes.bool,
    confirmText: PropTypes.string,
    dismissText: PropTypes.string
  };

  render() {
    const body = typeof this.props.body === 'string' ? <p>{this.props.body}</p> : this.props.body
    const handleDismiss = () => this.props.dismissConfirmationModal(this.props.onDismissCallback)

    return (
      <Modal
        id="my-modal"
        headerText={this.props.headerText}
        open={this.props.visible || false}
        size={this.props.size}
        onCancel={handleDismiss}>
        {body}
        <Modal.Footer>        
          <PrimaryButton disabled={this.props.confirmDisabled} onClick={() => { this.props.confirm(this.props.onConfirmCallback) }}>{this.props.confirmText}</PrimaryButton>
          <SecondaryButton onClick={handleDismiss}>{this.props.dismissText}</SecondaryButton>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = function (state) {
  return {
    visible: state.confirmationModal.visible
  };
};

const mapDispatchToProps = function (dispatch) {
  return bindActionCreators({ dismissConfirmationModal, confirm }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationModal);
